const routes = [
    {
        path: '/',
        component: () => import('../views/index/index'),
        meta:{
            keepAlive:true
        }
    },
    {
        path: '/index',
        name:'index',
        component: () => import('../views/index/index'),
        meta:{
            keepAlive:true
        }
        
    },   
    {
        path: '/route',
        component: () => import('../views/route/route'),
        meta:{
            keepAlive:false
        }
    },
    {
        path: '/routeDetail',
        component: () => import('../views/route/routeDetail'),
        meta:{
            keepAlive:false
        }
    }, 
    {
        path: '/detail/:id',
        component: () => import('../views/detail/detail'),
        meta:{
            keepAlive:false
        }
    },
    {
        path: '/round',
        component: () => import('../views/detail/round'),
        meta:{
            keepAlive:false
        }
    },
    {
        path: '/search',
        component: () => import('../views/search/search'),
        meta:{
            keepAlive:false
        }
    }, 
    {
        path: '/bank',
        component: () => import('../views/detail/bank'),
        meta:{
            keepAlive:false
        }
    },      

]
export default routes